import { render, staticRenderFns } from "./MultiplePaymentMethods.vue?vue&type=template&id=08726a64&scoped=true&"
import script from "./MultiplePaymentMethods.vue?vue&type=script&lang=js&"
export * from "./MultiplePaymentMethods.vue?vue&type=script&lang=js&"
import style0 from "./MultiplePaymentMethods.vue?vue&type=style&index=0&id=08726a64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08726a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VDialog,VExpandTransition,VIcon,VRow})
